// extracted by mini-css-extract-plugin
export default {"btn_container":"Buttons_btn_container__jAEcQ","btn_solid_blue":"Buttons_btn_solid_blue__Ig43H"};